import Omi, { bind, Component, h, tag } from "omi";
import tippy, { Instance, Props as TippyProps } from "tippy.js";
import tippyAnimations from "tippy.js/animations/scale-subtle.css?inline";
import tippyStyle from "tippy.js/dist/tippy.css?inline";

import { tailwind } from "@/tailwind";

import styles from "./styles.css?inline";

export type TooltipProps = {
  placement: "top" | "bottom" | "left" | "right" | "auto";
  content: string;
  trigger?: "click" | "hover";
  shouldShow?: boolean;
  arrow?: boolean;
  maxWidth?: string;
  delay?: [number, number];
  strategy?: "fixed" | "absolute";
  showDuration?: number;
  allowHtml?: boolean;
  zIndex?: number;
};

@tag("nw-tooltip")
export class NWTooltip extends Component<TooltipProps> {
  static css = [tailwind, tippyStyle, tippyAnimations, styles];
  static propTypes = {
    placement: String,
    content: String,
    trigger: String,
    maxWidth: String,
    shouldShow: Boolean,
    arrow: Boolean,
    strategy: String,
    showDuration: Number,
    allowHtml: Boolean,
    zIndex: Number,
  };

  private tippyInstance: Instance<TippyProps> | undefined;

  installed() {
    this.attachTooltip();
  }

  receiveProps(props: Omi.OmiProps<TooltipProps> | TooltipProps, oldProps: Omi.OmiProps<TooltipProps> | TooltipProps) {
    if (props.content !== oldProps.content) {
      this.tippyInstance?.setProps({ content: props.content });
    } else {
      return false;
    }
  }

  @bind
  private attachTooltip() {
    const options: Partial<TippyProps> = {
      content: this.props.content,
      placement: this.props.placement,
      maxWidth: this.props.maxWidth ?? "750px",
      interactive: true,
      arrow: this.props.arrow ?? true,
      hideOnClick: true,
      duration: [100, 100],
      delay: this.props.delay ?? undefined,
      animation: "scale-subtle",
      allowHTML: this.props.allowHtml ?? false,
      popperOptions: {
        strategy: this.props.strategy ?? "fixed",
      },
      onShow: () => {
        if (this.props.shouldShow === false) {
          return false;
        }
      },
    };

    if (this.props.zIndex) {
      options.zIndex = this.props.zIndex;
    }

    if (this.props.trigger) {
      options.trigger = this.props.trigger;

      options.onShow = instance => {
        if (this.props.trigger === "click") {
          if (this.props.shouldShow === false) {
            return false;
          }
          setTimeout(() => {
            instance.hide();
          }, this.props.showDuration ?? 1000);
        }
      };
    }

    this.tippyInstance = tippy(this.rootElement!, options);
  }

  render() {
    return (
      <div>
        <slot data-tooltip-target="tooltip-default"></slot>
      </div>
    );
  }
}
